import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import {
    INVOICE_COLUMN,
    INVOICE_TOURIST_COLUMN,
    INVOICE_VA_COLUMN,
    SALES_INVOICE_MODULE,
} from "../constant/salesReceiptConstant";

const subDomain = window.location.host.split('.')[0];
const invoiceColumns = (): Column[] => {
    if (subDomain === 'valeurs-assurances') return INVOICE_VA_COLUMN;
    if (subDomain === 'tourist-forum') return INVOICE_TOURIST_COLUMN;
    return INVOICE_COLUMN;
};

export const setSalesReceiptInvoicePreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SALES_INVOICE_MODULE,
        default_columns: invoiceColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
